export default __webpack_public_path__ + "static/media/Neophyte's Gauntlets of the Emperor's Favor.0122bbf1.jpg";